<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{'TITLE-BOAT-DETAIL-SERVICES' | translate}}</span>
        <div class="header-buttons">
            <button class="fab-button primary"  label="Exportar Excel" (click)="exportTable()"
              pTooltip="A exportação será de acordo com os filtros selecionados" tooltipPosition="left">
                    <i class="pi pi-file"></i>
                </button>
            <button class="fab-button primary " appFiltersButton pTooltip="Exibir/Ocultar Filtros"
                tooltipPosition="left">
                <i class="pi pi-filter"></i>
            </button>
        </div>
    </p-header>

    <form class="filters active" (submit)="this.getCustomers()" (keydown.enter)="$event.preventDefault()" (keyup.enter)="getCustomers()" appFilters>
        <div class="filter-row">
            <div class="form-control">
                <label for="customers">{{'CUSTOMER' | translate}}</label>
                <p-multiSelect [options]="customerList" [filter]="true" [(ngModel)]="customerFilter.customerIds"  name="customers" defaultLabel="Selecione..." selectedItemsLabel="{0} itens selecionados" appendTo="body" >
                </p-multiSelect>
            </div>

            <div class="form-control">
                <label for="rangeDateStart">{{'SERVICE-START' | translate}}</label>
                <p-calendar
                dateFormat="dd/mm/yy"
                name="rangeDateStart"
                [monthNavigator]="true"
                [yearNavigator]="true"
                appendTo="body"
                [yearRange]="'2000:2055'"
                rPCalendarMask
                selectionMode="range"
                [(ngModel)]="this.rangeDatesStart"
                [showIcon]="true"
                i18n
              >
              </p-calendar>
            </div>
            <div class="form-control">
                <label for="rangeDateEnd">{{'SERVICE-END' | translate}}</label>
                <p-calendar
                dateFormat="dd/mm/yy"
                name="rangeDateEnd"
                [monthNavigator]="true"
                [yearNavigator]="true"
                appendTo="body"
                [yearRange]="'2000:2055'"
                rPCalendarMask
                selectionMode="range"
                [(ngModel)]="this.rangeDatesEnd"
                [showIcon]="true"
                i18n
              >
              </p-calendar>
            </div>

            <div class="form-control">
                <label for="active">{{'Status Cliente' | translate}}</label>
                <p-dropdown [(ngModel)]="customerFilter.active" name="active" appendTo="body"
                    [options]="[{label: 'Ambos', value: null}, {label: 'Ativo', value: true}, {label: 'Inativo', value: false}]">
                </p-dropdown>
            </div>

            <div class="form-control">
                <label for="active">{{'SERVICE-STATUS' | translate}}</label>
                <p-dropdown [(ngModel)]="customerFilter.serviceStatus" name="active" appendTo="body"
                    [options]="[{label: 'Ambos', value: null}, {label: 'Ativo', value: true}, {label: 'Inativo', value: false}]">
                </p-dropdown>
            </div>

            <div class="form-control">
                <label for="grouped">{{'Serviços Vigentes' | translate}}</label>
                <p-checkbox [ngModelOptions]="{standalone: true}" [binary]="true" [(ngModel)]="this.customerFilter.serviceInEffect" inputId="binary">
                </p-checkbox>
            </div>

            <div class="form-control">
                <label for="serviceTypes">{{'Serviço Periódico - Cliente' | translate}}</label>
                <p-multiSelect [defaultLabel]="'Serviços'" [options]="serviceTypesList" [(ngModel)]="customerFilter.serviceTypesList"
                     appendTo="body" selectedItemsLabel="{0} itens selecionados" name="serviceTypes">
                </p-multiSelect>
            </div>

            <div class="buttons">
                <div class="form-button">
                    <button (click)="clear()" class="easymarine danger" type="button">{{ 'CLEAR' | translate }}</button>
                </div>
                <div class="form-button">
                    <button class="easymarine primary" type="submit">{{ 'FIND' | translate }}</button>
                </div>
            </div>
        </div>
    </form>


    <div class="table">
        <p-table #tt [value]="customers" [autoLayout]="true" [columns]="cols"
            [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 50, 75, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th class="th-border-left">
                        <span>Totais projetados</span>
                    </th>
                    <th class="text-center th-border-left">Serviços</th>
                    <th class="text-center th-border-left">%</th>
                    <th class="text-center th-border-left">Descontos</th>
                    <th class="text-center th-border-left">%</th>
                    <th class="text-center th-border-left">Descontos Vencimento</th>
                    <th class="text-center th-border-left">%</th>
                    <th class="text-center th-border-left">Serviços com Descontos</th>
                    <th class="text-center th-border-left">%</th>
                    <th colspan="6" class="th-border-left"> </th>
                </tr>
                <tr>
                    <th class="th-border-left">Anual</th>
                    <th class="text-right th-border-left">{{(totalValue * 12) | dynamicCurrency: currentCurrency}}</th>
                    <th rowspan="2" class="text-center th-border-left">{{1 | percent: '1.0-2'}}</th>
                    <th class="text-center th-border-left">{{(totalDesc * 12) | dynamicCurrency: currentCurrency}}</th>
                    <th rowspan="2" class="text-center th-border-left">{{((totalDesc) / totalValue) | percent: '1.0-2'}}</th>
                    <th class="text-center th-border-left">{{(totalDescVenc * 12) | dynamicCurrency: currentCurrency}}</th>
                    <th rowspan="2" class="text-center th-border-left">{{((totalDescVenc) / totalValue) | percent: '1.0-2'}}</th>
                    <th class="text-right th-border-left">{{(total * 12) | dynamicCurrency: currentCurrency}}</th>
                    <th rowspan="2" class="text-center th-border-left">{{((total) / totalValue) | percent: '1.0-2'}}</th>
                    <th colspan="9"> </th>
                </tr>
                <tr>
                    <th class="th-border-left">Mensal</th>
                    <th class="text-right th-border-left">{{totalValue | dynamicCurrency: currentCurrency}}</th>
                    <th class="text-center th-border-left">{{totalDesc | dynamicCurrency: currentCurrency}}</th>
                    <th class="text-center th-border-left">{{totalDescVenc | dynamicCurrency: currentCurrency}}</th>
                    <th class="text-right th-border-left">{{total | dynamicCurrency: currentCurrency}}</th>
                    <th colspan="9"> </th>
                </tr>
                <tr>
                    <th colspan="18"></th>
                </tr>
                <tr>
                    <th>Status</th>
                    <th>Cliente</th>
                    <th>CPF/CNPJ</th>
                    <th>Beneficiário</th>
                    <th>Início Serviço</th>
                    <th>Fim Serviço</th>
                    <th colspan="2">Serviço</th>
                    <th>Valor</th>
                    <th>Desc. Venc.</th>
                    <th>Desc.</th>
                    <th>%Desc.</th>
                    <th>Total</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
                 <tr>
                    <td class="text-center">
                        <span [pTooltip]="customer.active ? 'Cliente Ativa' : 'Cliente Inativa'" class="badge badge-pill size-badge"
                         [ngClass]="{'success':customer.active, 'danger': !customer.active}" tooltipPosition="top">
                        </span>
                    </td>
                    <td>{{customer.name}}</td>
                    <td>{{customer.federalId}}</td>
                    <td>
                        <ul *ngFor="let service of customer.serviceCustomer" class="ul-list">
                            <li>
                                {{service.beneficiaryName}}
                            </li>
                        </ul>
                    </td>

                    <td class="text-center">
                        <ul *ngFor="let service of customer.serviceCustomer" class="ul-list">
                            <li>
                                {{ service.contractStartDate | date:'dd/MM/yy'}}
                            </li>
                        </ul>
                    </td>

                    <td class="text-center">
                        <ul *ngFor="let service of customer.serviceCustomer" class="ul-list">
                            <li>
                                {{ service.contractEndDate != null ? ( service.contractEndDate| date:'dd/MM/yy') : '----'}}
                            </li>
                        </ul>
                    </td>


                    <td colspan="2">
                        <ul class="ul-list">
                            <li *ngFor="let service of customer.serviceCustomer">
                                 <span *ngIf="service" [pTooltip]="service.active ? 'Serviço Ativo' : 'Serviço Inativo'"
                                 [ngClass]="{'successFont':service.active, 'dangerFont': !service.active}" tooltipPosition="top">
                                 {{service.service != null ? service.service.name : '----'}}
                                </span>
                                <span *ngIf="!service">----</span>
                            </li>
                        </ul>
                    </td>

                    <td>
                        <ul class="ul-list ul-list-right">
                            <li *ngFor="let service of customer.serviceCustomer" >
                                {{service.value | dynamicCurrency: currentCurrency}}
                            </li>
                        </ul>
                    </td>
                    <td>
                        <ul class="ul-list ul-list-right">
                            <li *ngFor="let service of customer.serviceCustomer" >
                                {{service.dueDateDiscount | dynamicCurrency: currentCurrency}}
                            </li>
                        </ul>
                    </td>
                    <td>
                        <ul class="ul-list ul-list-right">
                            <li *ngFor="let service of customer.serviceCustomer" >
                                {{service.discount | dynamicCurrency: currentCurrency}}
                            </li>
                        </ul>
                    </td>
                    <td>
                        <ul class="ul-list ul-list-right">
                            <li *ngFor="let service of customer.serviceCustomer">
                                {{getPercentDiscountOfTotalService(service) | percent: '1.0-2'}}
                            </li>
                        </ul>
                    </td>
                    <td>
                        <ul class="ul-list ul-list-right">
                            <li *ngFor="let service of customer.serviceCustomer">
                                {{getTotalService(service) | dynamicCurrency: currentCurrency}}
                            </li>
                        </ul>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="100%" style="text-align: center; padding: 3rem 1rem;">
                        <div class="empty-state" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px;">
                            <i class="pi pi-search" style="font-size: 4rem; color: #6c757d; margin-bottom: 1rem;"></i>
                            <p style="color: #6c757d; font-size: 1.1rem; margin: 0; max-width: 400px; text-align: center;">
                                Adicione algum filtro, ou apenas clique em Pesquisar para exibir os dados
                            </p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>
